import { render, staticRenderFns } from "./FieldHolder.vue?vue&type=template&id=0b03b0b0&scoped=true&"
import script from "./FieldHolder.vue?vue&type=script&lang=js&"
export * from "./FieldHolder.vue?vue&type=script&lang=js&"
import style0 from "./FieldHolder.vue?vue&type=style&index=0&id=0b03b0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03b0b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b03b0b0')) {
      api.createRecord('0b03b0b0', component.options)
    } else {
      api.reload('0b03b0b0', component.options)
    }
    module.hot.accept("./FieldHolder.vue?vue&type=template&id=0b03b0b0&scoped=true&", function () {
      api.rerender('0b03b0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Forms/Fields/FieldHolder.vue"
export default component.exports